import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";

export function passwordScore(p) {
  if (!p) return 0;
  let s = 0;
  if (p.length >= 8) s++;
  if (p.length >= 12) s++;
  if (/[a-z]/.test(p) && /[A-Z]/.test(p)) s++;
  if (/\d/.test(p)) s++;
  if (/[^A-Za-z0-9]/.test(p)) s++;
  return Math.min(s, 4);
}

export const passwordValid = (p) => p.length >= 8 && /[A-Za-z]/.test(p) && /\d/.test(p);

export function PasswordField({ label, value, onChange, testid, autoComplete = "new-password" }) {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <div className="mt-1 flex items-center rounded-lg border border-border bg-secondary/50 focus-within:ring-2 focus-within:ring-accent/50">
        <input required type={show ? "text" : "password"} value={value} autoComplete={autoComplete} data-testid={testid}
          onChange={(e) => onChange(e.target.value)} className="w-full bg-transparent px-3 py-2.5 text-sm outline-none" />
        <button type="button" onClick={() => setShow((s) => !s)} data-testid={`${testid}-toggle`}
          aria-label={show ? t("pwd.hide") : t("pwd.show")}
          className="px-3 text-muted-foreground transition-colors hover:text-foreground">
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}

const LEVELS = ["bg-red-500", "bg-orange-500", "bg-yellow-500", "bg-lime-500", "bg-emerald-500"];

export function StrengthMeter({ password }) {
  const { t } = useTranslation();
  const s = passwordScore(password);
  return (
    <div data-testid="password-strength" data-score={s}>
      <div className="mt-2 flex gap-1">
        {[0, 1, 2, 3].map((i) => <span key={i} className={`h-1.5 flex-1 rounded-full ${password && i < Math.max(s, 1) ? LEVELS[s] : "bg-border"}`} />)}
      </div>
      <p className="mt-1 text-xs text-muted-foreground">
        {password ? t("pwd.strength", { level: t(`pwd.l${s}`) }) : t("pwd.hint")}
      </p>
    </div>
  );
}
